import React from "react"
import { withObjectiveAnalyticsContainer, SearchIcon } from "../../normalizer"

import ObjectivesFilter from "./ObjectivesFilter"
import ObjectivesTable from "./ObjectivesTable"
import EmptyStateLayout from "../../shared/EmptyStateLayout"

const Objectives = props => {
  const {
    objectives,
    pagination,
    onPageChange,
    onObjectiveFilter,
    filtered,
    group,
    page
  } = props

  const noObjectives = objectives.length === 0
  const noObjectivesWhileFiltering = filtered && noObjectives
  const noObjectivesWhileNotFiltering = !filtered && noObjectives

  const EmptyStateContent = (
    <div className="w-full flex items-center flex-col">
      <div className="gl-objectives__line mt-5 mb-10 w-full" />
      <SearchIcon className="mb-10" />
    </div>
  )

  const tablePagination = pagination.total_pages > 1
    ? { totalPages: pagination.total_pages, currentPage: page, onPageChange }
    : undefined

  return (
    <div className="analytics-layout-content">
      {noObjectivesWhileNotFiltering ? (
        <EmptyStateLayout message="Ainda não existem objetivos registados para esta loja.">
          {EmptyStateContent}
        </EmptyStateLayout>
      ) : (
        <>
          <ObjectivesFilter onObjectiveFilter={onObjectiveFilter} />
          {noObjectivesWhileFiltering ? (
            <EmptyStateLayout message="Não existem resultados com critérios de pesquisa introduzidos.">
              {EmptyStateContent}
              <h1 className="mb-5 normal-case">Sem resultados!</h1>
            </EmptyStateLayout>
          ) : (
            <ObjectivesTable group={group} objectives={objectives} pagination={tablePagination} />
          )}
        </>
      )}
    </div>
  )
}

export default withObjectiveAnalyticsContainer(Objectives)
